import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { AssetClass } from "@api/v1/hooks/performance/assetClasses";
import { MultiSelect } from "@components/MobileList";
import { useAssetClassFilter } from "../assetClassFilter";

const titleKey = (assetClass: AssetClass) =>
  assetClass === "holdings" ? "allHoldings" : assetClass;

// With a single class there is nothing to filter.
export const useShowsAssetClassSetting = () =>
  useAssetClassFilter().availableClasses.length >= 2;

// The page's asset class filter, the same one the cards above toggle.
export const AssetClassSetting = () => {
  const { t } = useTranslation();
  const { activeClasses, availableClasses, setActiveClasses } =
    useAssetClassFilter();
  const isShown = useShowsAssetClassSetting();

  if (!isShown) return null;

  return (
    <Box data-testid="asset-class-setting">
      <MultiSelect
        label={t("assetTypeBreakdown.filter.label")}
        options={availableClasses.map((assetClass) => ({
          value: assetClass,
          label: t(`assetTypeBreakdown.${titleKey(assetClass)}.title`),
        }))}
        selected={activeClasses}
        onChange={setActiveClasses}
        allLabel={t("assetTypeBreakdown.filter.all")}
        countLabel={(count) =>
          t("assetTypeBreakdown.filter.selected", { count })
        }
      />
    </Box>
  );
};
